import React from 'react';

type Props = {
  currency: number | undefined;
};
/**
 *
 * @param [currency] - Number to be formatted
 * @returns
 */
export const CurrencyCell = ({ currency }: Props) => {
  if (!currency) {
    return <span>0 kr</span>;
  }

  return <span>{(+currency).toLocaleString('nb') + ' kr'}</span>;
};
